var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuides(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.6042,
    fill: "white",
    stroke: "#40798C",
    strokeWidth: 1.79167
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8033 9.75619V14.6342C12.8033 15.1194 12.6106 15.5847 12.2675 15.9277C11.9245 16.2708 11.4592 16.4635 10.974 16.4635H9.65088C9.50703 16.8705 9.22393 17.2136 8.85161 17.432C8.47928 17.6505 8.04172 17.7303 7.61625 17.6573C7.19078 17.5843 6.80482 17.3633 6.52657 17.0332C6.24832 16.7032 6.0957 16.2854 6.0957 15.8538C6.0957 15.4221 6.24832 15.0043 6.52657 14.6743C6.80482 14.3442 7.19078 14.1232 7.61625 14.0502C8.04172 13.9772 8.47928 14.057 8.85161 14.2755C9.22393 14.4939 9.50703 14.837 9.65088 15.244H10.974C11.1358 15.244 11.2909 15.1798 11.4052 15.0654C11.5196 14.9511 11.5838 14.796 11.5838 14.6342V9.75619C11.5838 9.27104 11.7765 8.80576 12.1196 8.4627C12.4626 8.11965 12.9279 7.92692 13.4131 7.92692H15.2423V6.09766L18.2911 8.53668L15.2423 10.9757V9.14644H13.4131C13.2514 9.14644 13.0963 9.21068 12.9819 9.32503C12.8676 9.43938 12.8033 9.59448 12.8033 9.75619ZM7.92527 16.4635C8.08699 16.4635 8.24208 16.3993 8.35643 16.2849C8.47078 16.1706 8.53502 16.0155 8.53502 15.8538C8.53502 15.692 8.47078 15.5369 8.35643 15.4226C8.24208 15.3082 8.08699 15.244 7.92527 15.244C7.76355 15.244 7.60846 15.3082 7.49411 15.4226C7.37975 15.5369 7.31551 15.692 7.31551 15.8538C7.31551 16.0155 7.37975 16.1706 7.49411 16.2849C7.60846 16.3993 7.76355 16.4635 7.92527 16.4635Z",
    fill: "#40798C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/Guides.394b1027768b3c4742f8f2d455b8211b.svg";
export { ForwardRef as ReactComponent };